var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3618 6.15201L15.8418 4.67201C16.0276 4.48621 16.2481 4.33882 16.4908 4.23826C16.7335 4.1377 16.9936 4.08594 17.2563 4.08594C17.519 4.08594 17.7792 4.1377 18.0219 4.23826C18.2646 4.33882 18.4851 4.48621 18.6708 4.67201L20.0848 6.08601C20.4598 6.46107 20.6704 6.96968 20.6704 7.50001C20.6704 8.03034 20.4598 8.53895 20.0848 8.91401L18.6048 10.394M14.3618 6.15201L4.74583 15.767C4.41381 16.099 4.2092 16.5373 4.16783 17.005L3.92583 19.745C3.91284 19.8907 3.93194 20.0374 3.98181 20.1749C4.03167 20.3123 4.11108 20.4372 4.21444 20.5407C4.3178 20.6441 4.44259 20.7236 4.58002 20.7736C4.71744 20.8236 4.86416 20.8429 5.00983 20.83L7.74983 20.588C8.21826 20.5471 8.6573 20.3425 8.98983 20.01L18.6048 10.394M14.3618 6.15201L18.6048 10.394",
    stroke: "#505762",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3399f529d48a830764481216ce5a4808.svg";
export { ForwardRef as ReactComponent };